const params = new URLSearchParams(location.search);
const title = params.get('quote_product_title');
let context = '';
if (title && params.get('quote_product_url')) {
  try {
    const productUrl = new URL(params.get('quote_product_url'), location.origin);
    if (productUrl.origin === location.origin && productUrl.pathname.startsWith('/products/')) {
      // The staff email labels this field "Product:", so the title goes in unlabelled.
      const lines = [title, productUrl.href];
      const quantity = params.get('quote_quantity');
      const options = params.get('quote_options');
      if (quantity) lines.push(`Quantity: ${quantity}`);
      if (options) lines.push(`Options: ${options}`);
      context = lines.join('\n');
    }
  } catch {
    // An invalid URL leaves the contact form unchanged.
  }
}

const fillProductContext = () => {
  const selector = 'textarea[name="custom#product_context"]';
  const formsRoot = document.querySelector('shopify-forms-embed')?.shadowRoot;
  const field = document.querySelector(selector) || formsRoot?.querySelector(selector);
  if (!field) return false;

  Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')?.set?.call(field, context);
  field.dispatchEvent(new Event('input', { bubbles: true }));

  (field.parentElement || field).hidden = true;
  (field.parentElement || field).style.display = 'none';
  return true;
};

if (context && !fillProductContext()) {
  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    if (fillProductContext() || attempts === 100) clearInterval(interval);
  }, 100);
}
